import { render } from "./OtherSettingsTab.vue?vue&type=template&id=081a4239&scoped=true"
import script from "./OtherSettingsTab.vue?vue&type=script&lang=js"
export * from "./OtherSettingsTab.vue?vue&type=script&lang=js"

import "./OtherSettingsTab.vue?vue&type=style&index=0&id=081a4239&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081a4239"]])

export default __exports__